import type { AgentCredEvent, EventListener } from './types';

export class EventBus {
  private listeners: EventListener[] = [];

  on(fn: EventListener) {
    this.listeners.push(fn);
  }

  off(fn: EventListener) {
    this.listeners = this.listeners.filter(l => l !== fn);
  }

  emit(e: AgentCredEvent) {
    this.listeners.forEach(l => l(e));
  }

  // Phase 1: simulate ghost events
  startGhostSimulation() {
    const authorities = ['escrowhubs', 'naijalancers', 'oracle', 'minipay', 'quidax', 'gatekeeper'];
    const loop = () => {
      const delay = 500 + Math.random() * 2000;
      setTimeout(() => {
        const type = Math.random() < 0.9 ? 'GhostHit' : 'GhostExchange';
        const evt: AgentCredEvent = {
          type,
          timestamp: Date.now(),
          targetAuthority: authorities[Math.floor(Math.random() * authorities.length)],
          result: Math.random() < 0.8 ? 'granted' : 'denied',
          claims: type === 'GhostHit' ? ['read:profile'] : undefined,
        };
        this.emit(evt);
        loop();
      }, delay);
    };
    loop();
  }
}
